import React, { useState } from "react";
import styled from "@emotion/styled";

const Wrapper = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 40%;
  margin: auto;
  gap: 5px;

  input {
    width: 100%;
    margin: 8px 0;
    display: inline-block;
    border: 1px solid #ccc;
    box-shadow: inset 0 1px 3px #ddd;
    border-radius: 4px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  @media (max-width: 600px) {
    width: 80%;
    margin-top: 2rem;
  }

  // Tablets
  @media only screen and (min-width: 768px) {
    width: 70%;
  }

  // Laptops & Desktops
  @media only screen and (min-width: 992px) {
    width: 40%;
  }
`;

const WrapButton = styled("div")`
  display: flex;
  justify-content: space-between;
  gap: 5px;

  button {
    width: 100%;
    padding: 0.5rem;
    background-color: #1a3269;
    border: none;
    color: #fff;
  }
`;

const CopyToClipboard = ({ copyText, refreshBtn }) => {
  const [isCopied, setIsCopied] = useState(false);

  // This is the function we wrote earlier
  async function copyTextToClipboard(text) {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand("copy", true, text);
    }
  }

  // onClick handler function for the copy button
  const handleCopyClick = () => {
    // Asynchronously call copyTextToClipboard
    copyTextToClipboard(copyText)
      .then(() => {
        // If successful, update the isCopied state value
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Wrapper>
      <input type="text" value={copyText} readOnly />
      {/* Bind our handler function to the onClick button property */}
      <WrapButton>
        <button onClick={handleCopyClick}>
          <span>{isCopied ? "Copied!" : "Copy"}</span>
        </button>
        <button type="button" onClick={refreshBtn}>
          Refresh
        </button>
      </WrapButton>
    </Wrapper>
  );
};

export default CopyToClipboard;
